<script lang="ts">
  import { extractUidsWithTitle, isMobileWidth } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { getCMSComponentsFromHybrisAsync } from '../../common/services/hybris';
  import ContentCard from './ContentCard.svelte';
  import FooterNavigationComponent from './FooterNavigationComponent.svelte';
  import TopSection from './TopSection.svelte';

  export let metaData;
  console.log(metaData, 'metaData');

  const FooterMiddleAData = metaData.find(item => item.position === 'FooterMiddleA');
  const FooterMiddleBData = metaData.find(item => item.position === 'FooterMiddleB');
  const FooterMiddleCData = metaData.find(item => item.position === 'FooterMiddleC');
  let navNodeData = [];

  const isResponsive = isMobileWidth();

  // Fetch footer data asynchronously for navigation nodes
  async function getFooterDataForNavNode(navNode) {
    try {
      navNodeData = await extractUidsWithTitle(navNode);
      const promises = navNodeData.map(async item => {
        try {
          const cmsComponents = await getCMSComponentsFromHybrisAsync(item.components);
          item.components = cmsComponents.component;
          return item;
        } catch (err) {
          console.error(`Error fetching CMS components for item: ${item.id}`, err);
          return { ...item, components: [] }; // Return fallback in case of error
        }
      });
      return await Promise.all(promises);
    } catch (error) {
      console.error('Error fetching footer data for navigation node:', error);
      return []; // Return empty array if there's a failure
    }
  }

  // Pre-fetch footer navigation data when necessary (outside of the render cycle)
  async function fetchNavNodeData(navNode) {
    try {
      navNodeData = await getFooterDataForNavNode(navNode);
      return navNodeData || []; // Ensure it returns an array
    } catch (error) {
      console.error('Error fetching footer data for navigation node:', error);
      return []; // Return an empty array in case of error
    }
  }
</script>

<div class="c_wrapper--content_new">
  <div class="c_link-content c_link-content-footer">
    <div class="container-fluid middle-content row-flex">
      <div class="middle-content-left row-flex col-flex-md-12">
        <!-- Footer Middle A Data (Responsive check) -->
        {#if !isResponsive && FooterMiddleAData?.components?.component?.length}
          <div class="col-flex-md-4">
            {#each FooterMiddleAData.components.component as comp}
              {#if comp.typeCode === 'CMSParagraphComponent'}
                <TopSection metaData={comp.content} />
              {:else if comp.typeCode === 'FooterNavigationComponent'}
                {#await fetchNavNodeData(comp.navigationNode)}
                  <p>Loading...</p>
                {:then data}
                  {#each data as navData}
                    <div class="p-0">
                      <FooterNavigationComponent data={navData} />
                    </div>
                  {/each}
                {:catch error}
                  <p>Error loading navigation data. More info: {error}</p>
                {/await}
              {/if}
            {/each}
          </div>
        {/if}

        <!-- Footer Middle B Data (Fetch Footer Navigation Data for NavNode) -->
        {#if FooterMiddleBData?.components?.component?.length}
          <div class="col-flex-md-5 p-0 links-section">
            {#each FooterMiddleBData.components.component as comp}
              {#if comp.typeCode === 'CMSParagraphComponent'}
                <TopSection metaData={comp.content} />
              {:else if comp.typeCode === 'FooterNavigationComponent'}
                {#await fetchNavNodeData(comp.navigationNode)}
                  <p>Loading...</p>
                {:then data}
                  {#each data as navData}
                    <div class="p-0">
                      <FooterNavigationComponent data={navData} />
                    </div>
                  {/each}
                {:catch error}
                  <p>Error loading navigation data. More info: {error}</p>
                {/await}
              {/if}
            {/each}
          </div>
        {/if}

        <!-- Footer Middle C Data -->
        {#if FooterMiddleCData?.components?.component?.length}
          <div class="needhelp-social middle-content-right col-flex-md-3">
            {#if isResponsive}
              <div class="p-0">
                <ContentCard title="Contact Us" collpasableId="contactUs">
                  <nav class="nav flex-column mb-5">
                    {#each FooterMiddleCData.components.component as comp}
                      {#if comp.content}
                        <div class="content">
                          {@html comp.content}
                        </div>
                      {/if}
                    {/each}
                  </nav>
                </ContentCard>
              </div>
            {:else}
              <a class="js-footer-second-level-toggle title" data-toggle="collapse" href="#footerContactUs">
                <span class="hidden-md hidden-lg">
                  <Icon glyph="chevron_down" />
                </span>
                <Text key="contactUs.title" />
              </a>
              <div class="footer__nav--links" role="tabpanel" id="footerContactUs">
                {#each FooterMiddleCData.components.component as com}
                  {#if com.content}
                    <div class="content">
                      {@html com.content}
                    </div>
                  {/if}
                {/each}
              </div>
            {/if}
          </div>
        {/if}

        {#if isResponsive && FooterMiddleAData?.components?.component?.length}
          <div class="col-flex-md-4">
            {#each FooterMiddleAData.components.component as comp}
              {#if comp.typeCode === 'CMSParagraphComponent'}
                <TopSection metaData={comp.content} />
              {:else if comp.typeCode === 'FooterNavigationComponent'}
                {#await fetchNavNodeData(comp.navigationNode)}
                  <p>Loading...</p>
                {:then data}
                  {#each data as navData}
                    <div class="p-0">
                      <FooterNavigationComponent data={navData} />
                    </div>
                  {/each}
                {:catch error}
                  <p>Error loading navigation data. More info: {error}</p>
                {/await}
              {/if}
            {/each}
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/vars';
  .middle-section {
    // padding: 3rem 0 0;
    @include desktop-max-width {
      background-color: $neutral-dark-01;
    }
    .container-fluid {
      justify-content: space-around;
      padding: 0 48px;
      @include desktop-max-width {
        padding: 0 20px;
        width: auto;
      }
      .col-flex-md-5 {
        display: flex;
        gap: 60px;
        white-space: nowrap;
        @include desktop-max-width {
          gap: 0;
          flex-direction: column;
        }
      }
      .footer__nav--links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .middle-content-right {
        .title {
          :global(.c_icon_new--chevron_down) {
            font-weight: 700;
            filter: drop-shadow(0 0 1px currentColor);
            text-shadow:
              0 0 1px currentColor,
              0 0 1px currentColor;
          }
        }
        @include desktop-min-width {
          padding: 0 0 0 74px;
        }
        .nav {
          .content {
            @include desktop-max-width {
              padding: 0 20px;
            }
          }
        }
      }
    }
    .social-icon {
      font-size: 1.5rem;
    }
    .call-service {
      font-size: 1.7rem;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 1.59;

      .c_icon--call {
        color: $color-white;
        font-size: 1.8rem;
        opacity: 1;
        padding: 0;
        -webkit-transform: translate3d(0, -50%, 0);
        transform: translate3d(0, -50%, 0);
      }
      span {
        color: $color-white;
        font-size: 1.4rem;
        font-weight: 300;
        line-height: 1.43;
        opacity: 0.4;
      }
      a {
        color: $color-white;
        text-decoration: none;
      }
    }

    .nav {
      .nav-link {
        color: $color-white;
        display: block;
        font-size: 1.3rem;
        font-weight: 600;
        line-height: 1.3;
        padding: 1.1rem 1.5rem;
      }
      .nav-link.active,
      .nav-link:hover {
        text-decoration: underline;
      }
    }
    .links {
      .social-links {
        justify-content: flex-start;
        padding: 0;

        a {
          align-items: center;
          border-radius: 50%;
          box-shadow: 0 0 0 0.1rem $color-oslo-gray;
          color: $color-white;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          font-size: 1.8rem;
          height: 3.2rem;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          margin-right: 1.2rem;
          position: relative;
          transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1);
          width: 3.2rem;
          text-decoration: none;

          span {
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            font-size: 1.8rem;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            transition: all 0.6s cubic-bezier(0.19, 1, 0.22, 1);
          }
        }

        a:hover {
          box-shadow: 0 0 0 0.1rem $color-white;
          color: $color-ebony-clay;
          background: $color-white;
        }
      }

      @media (max-width: 992px) {
        display: flex;
        justify-content: center;

        .social-links {
          justify-content: center;
        }
      }
    }

    .we-accept {
      padding: 1.8rem 0 1.1rem;
      text-align: center;
      .cards {
        img {
          margin: 1rem 1rem 0.8rem 1rem;
          max-width: 10.5rem;
          vertical-align: middle;
        }
      }
    }

    @media screen and (min-width: 1024px) {
      .we-accept {
        padding-bottom: 8rem;
      }
      .nav {
        .nav-link {
          font-size: 1.4rem;
          line-height: 2.14;
          padding: 0;
          margin-bottom: 0.5rem;
        }
      }
    }
  }

  .c_footer-secured {
    align-items: center;
    display: flex;
    justify-content: center;
  }
</style>
